/* Used global Wordpress php variables to the ajax requests */
/* global themeVars */

/**
 * Theme Settings
 */

const themeSettings = { ...themeVars }

const cookiebotGroupId = 'e672640c-d73e-427e-b291-a9713ba855f4'

const postTypes = [
	{ label: 'Post', value: 'post' },
	{ label: 'Guide', value: 'smoobu_guide' },
	{ label: 'Vacation Rentals Templates', value: 'smoobu_vr' },
	{ label: 'Success Story', value: 'smoobu_success_story' },
]


const themeColors = [

	{
		'name': 'Black',
		'slug': 'color-black',
		'color': '#000000'
	},
	{
		'name': 'White',
		'slug': 'color-white',
		'color': '#ffffff'
	},
	{
		'name': 'Blue',
		'slug': 'color-blue',
		'color': '#0f62fe'
	},
	{
		'name': 'Blue Light',
		'slug': 'color-blue-light',
		'color': '#edf5ff'
	},
	{
		'name': 'Gray Text',
		'slug': 'color-gray-text',
		'color': '#697077'
	},
	{
		'name': 'Gray light',
		'slug': 'color-gray-light',
		'color': '#f7f8fb'
	},
	{
		'name': 'Green super light',
		'slug': 'color-green-super-light',
		'color': '#E4F9F7'
	}

];

export {
	themeSettings,
	postTypes,
	themeColors,
	cookiebotGroupId
};
